import { loadEffectsIni, getEffectsList } from "../utils/effectsIni";

/**
 * Effects rendered by the client itself rather than loaded from effects.ini.
 * Rain is a webAO CSS effect (a field of animated raindrops) with no entry in
 * the manifest, so it has to be appended by hand or it would disappear the
 * moment the dropdown is generated from the ini.
 */
const CLIENT_EFFECTS: { label: string; value: string }[] = [
  { label: "Weak Rain", value: "rain-weak||sfx-rain" },
  { label: "Rain", value: "rain||sfx-rain" },
  { label: "Strong Rain", value: "rain-strong||sfx-rain" },
];

/** "dramaholdit" -> "Dramaholdit". AO2 shows the raw ini name; just cased. */
const toLabel = (name: string): string =>
  name.charAt(0).toUpperCase() + name.slice(1);

/**
 * Build the IC effect dropdown from the theme's effects.ini.
 *
 * The option value is the wire format AO2 expects for the effects field,
 * "name|folder|sound". webCOA sends no custom folder, so it is left empty and
 * the value becomes "name||sound"; the receiving client reads the sound from
 * the third segment. Effects with no sound in the ini get an empty third
 * segment and therefore play silently, which is what AO2 does.
 *
 * If effects.ini is missing or unreadable the markup's built-in options are
 * left untouched, so a server without an effects pack keeps working.
 */
export async function populateEffects(): Promise<void> {
  const effect_select = <HTMLSelectElement>(
    document.getElementById("effect_select")
  );
  if (!effect_select) {
    return;
  }

  await loadEffectsIni();
  const effects = getEffectsList();
  if (effects.length === 0) {
    return;
  }

  effect_select.innerHTML = "";
  effect_select.add(new Option("None", "||"));
  for (const effect of effects) {
    effect_select.add(
      new Option(toLabel(effect.name), `${effect.name}||${effect.sound}`),
    );
  }
  for (const effect of CLIENT_EFFECTS) {
    effect_select.add(new Option(effect.label, effect.value));
  }
}
